import { Action, configureStore, ThunkAction } from "@reduxjs/toolkit"
import configSlice from "~/slices/configSlice"
import authorizationSlice from "~/slices/authorizationSlice"
import { Dispatch, MiddlewareAPI } from "redux"
import temporarySlice from "~/slices/temporarySlice"

import CryptoJS from "crypto-js"

const storeKey = "AMBITION-CLOUD"

const save = ({ getState }: MiddlewareAPI) => {
  return (next: Dispatch) => (action: any) => {
    const result = next(action)
    const ciphertext = CryptoJS.AES.encrypt(JSON.stringify(getState()), storeKey).toString()
    sessionStorage.setItem(storeKey, ciphertext)
    // sessionStorage.setItem(storeKey, JSON.stringify(getState()))
    return result
  }
}
//
const load = () => {
  if (typeof Storage !== "undefined") {
    if (sessionStorage.getItem(storeKey) !== null) {
      try {
        const bytes = CryptoJS.AES.decrypt(sessionStorage.getItem(storeKey), storeKey)
        return JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
      } catch (e) {
        sessionStorage.clear()
        location.href = "/"
      }
    }
  }
  return {}
}

export const store = configureStore({
  reducer: {
    config: configSlice,
    authorization: authorizationSlice,
    // customTheme: customThemeSlice,
    temporary: temporarySlice,
  },
  preloadedState: load(),
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(save),
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>
